import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const FilterBar = ({ onFilterChange, onSearchChange, activeFilters }) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'submitted', label: 'Submitted' },
    { value: 'under-review', label: 'Under Review' },
    { value: 'shortlisted', label: 'Shortlisted' },
    { value: 'interview-scheduled', label: 'Interview Scheduled' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'offer-received', label: 'Offer Received' }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Newest First' },
    { value: 'date-asc', label: 'Oldest First' },
    { value: 'company-asc', label: 'Company A-Z' },
    { value: 'company-desc', label: 'Company Z-A' },
    { value: 'status', label: 'By Status' }
  ];

  const jobTypeOptions = [
    { value: 'all', label: 'All Types' },
    { value: 'full-time', label: 'Full Time' },
    { value: 'part-time', label: 'Part Time' },
    { value: 'contract', label: 'Contract' },
    { value: 'internship', label: 'Internship' }
  ];

  const timeRangeOptions = [
    { value: 'all', label: 'All Time' },
    { value: 'today', label: 'Today' },
    { value: 'week', label: 'This Week' },
    { value: 'month', label: 'This Month' },
    { value: 'quarter', label: 'Last 3 Months' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by job title, company, or location..."
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <Select
            options={statusOptions}
            value={activeFilters?.status}
            onChange={(value) => onFilterChange('status', value)}
            placeholder="Status"
            className="w-48"
          />
          <Select
            options={sortOptions}
            value={activeFilters?.sort}
            onChange={(value) => onFilterChange('sort', value)}
            placeholder="Sort by"
            className="w-48"
          />
          <Select
            options={jobTypeOptions}
            value={activeFilters?.jobType}
            onChange={(value) => onFilterChange('jobType', value)}
            placeholder="Job Type"
            className="w-48"
          />
          <Select
            options={timeRangeOptions}
            value={activeFilters?.timeRange}
            onChange={(value) => onFilterChange('timeRange', value)}
            placeholder="Time Range"
            className="w-48"
          />
        </div>

        <Button
          variant="outline"
          size="default"
          iconName="Filter"
          iconPosition="left"
          onClick={() => setShowMobileFilters(!showMobileFilters)}
          className="lg:hidden"
        >
          Filters
        </Button>
      </div>
      {showMobileFilters && (
        <div className="lg:hidden mt-4 pt-4 border-t border-border space-y-3">
          <Select
            label="Status"
            options={statusOptions}
            value={activeFilters?.status}
            onChange={(value) => onFilterChange('status', value)}
          />
          <Select
            label="Sort by"
            options={sortOptions}
            value={activeFilters?.sort}
            onChange={(value) => onFilterChange('sort', value)}
          />
          <Select
            label="Job Type"
            options={jobTypeOptions}
            value={activeFilters?.jobType}
            onChange={(value) => onFilterChange('jobType', value)}
          />
          <Select
            label="Time Range"
            options={timeRangeOptions}
            value={activeFilters?.timeRange}
            onChange={(value) => onFilterChange('timeRange', value)}
          />
        </div>
      )}
      {(activeFilters?.status !== 'all' || activeFilters?.jobType !== 'all' || activeFilters?.timeRange !== 'all') && (
        <div className="flex flex-wrap items-center gap-2 mt-4 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">Active Filters:</span>
          {activeFilters?.status !== 'all' && (
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>{statusOptions?.find(opt => opt?.value === activeFilters?.status)?.label}</span>
              <button onClick={() => onFilterChange('status', 'all')} className="hover:opacity-70">
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {activeFilters?.jobType !== 'all' && (
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>{jobTypeOptions?.find(opt => opt?.value === activeFilters?.jobType)?.label}</span>
              <button onClick={() => onFilterChange('jobType', 'all')} className="hover:opacity-70">
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          {activeFilters?.timeRange !== 'all' && (
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>{timeRangeOptions?.find(opt => opt?.value === activeFilters?.timeRange)?.label}</span>
              <button onClick={() => onFilterChange('timeRange', 'all')} className="hover:opacity-70">
                <Icon name="X" size={14} />
              </button>
            </div>
          )}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onFilterChange('reset', null)}
            className="text-muted-foreground"
          >
            Clear All
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterBar;